import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { adminApi } from '../api/admin';
import type { AdminSettings } from '../api/types';

export const ADMIN_KEYS = {
  blacklist: ['admin', 'blacklist'] as const,
  whitelist: ['admin', 'whitelist'] as const,
  settings: ['admin', 'settings'] as const,
  accessLogs: ['admin', 'accessLogs'] as const,
};

// Blacklist
export function useBlacklist() {
  return useQuery({ queryKey: ADMIN_KEYS.blacklist, queryFn: () => adminApi.listBlacklist().then((r) => r.items) });
}

export function useAddBlacklist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ip, reason }: { ip: string; reason?: string }) => adminApi.addBlacklist(ip, reason),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_KEYS.blacklist }),
  });
}

export function useRemoveBlacklist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ip: string) => adminApi.removeBlacklist(ip),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_KEYS.blacklist }),
  });
}

// Whitelist
export function useWhitelist() {
  return useQuery({ queryKey: ADMIN_KEYS.whitelist, queryFn: () => adminApi.listWhitelist().then((r) => r.items) });
}

export function useAddWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ ip, description }: { ip: string; description?: string }) =>
      adminApi.addWhitelist(ip, description),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_KEYS.whitelist }),
  });
}

export function useRemoveWhitelist() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ip: string) => adminApi.removeWhitelist(ip),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_KEYS.whitelist }),
  });
}

// Settings
export function useAdminSettings() {
  return useQuery({ queryKey: ADMIN_KEYS.settings, queryFn: () => adminApi.getSettings() });
}

export function useUpdateAdminSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Partial<AdminSettings>) => adminApi.patchSettings(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_KEYS.settings }),
  });
}
